var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderConsignmentVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 224,
    viewBox: "0 0 467 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3134_18038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1369 223.367H429.809C444.594 167.082 474.797 90.8265 423.969 43.3052C398.908 16.7797 362.189 4.65726 326.273 11.0461L97.9416 51.6732C44.7127 60.2231 8.69211 115.122 21.4002 167.262L34.1369 223.365V223.367Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.864 2.73364H290.805V223.365H341.864V2.73364Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.267 -0.237549H341.863V223.367H368.267V-0.237549Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.0234 223.367V132.072H125.705V187.922H230.06V230.422H15.0234V223.367Z",
    fill: "#F1F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.098 90.7692L104.325 90.2252L100.726 85.2344L93.5039 90.5452L94.7005 98.4601C95.1869 102.209 99.1721 104.851 102.811 103.84C106.862 102.92 140.447 93.6579 143.766 94.3957C144.299 94.2357 147.287 90.7675 147.287 90.7675H137.096L137.098 90.7692Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.691 90.4963C120.691 90.4963 134.618 94.7089 147.287 92.819L149.706 89.489L120.691 90.4963Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3633 63.2769L102.22 84.1345L92.597 91.2088L86.3633 63.2769Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2181 30.8696C78.0226 31.3379 81.7891 35.7307 80.6901 39.1433L75.7539 33.061L77.2181 30.8696Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.533 43.8998C66.5621 58.3804 84.2652 53.7399 80.6872 39.1431C76.6582 24.6626 58.9551 29.303 62.533 43.8998Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7408 35.5217C79.7408 35.5217 70.3751 41.4759 65.5938 37.5008C60.8125 33.5257 65.5938 37.5008 65.5938 37.5008L76.6475 31.7234L79.7408 35.5217Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.365 43.1655C62.365 43.1655 67.7168 59.9975 67.2405 65.5239C67.2405 65.5239 73.3396 65.758 78.4575 62.5847C78.4575 62.5847 71.1366 48.9362 70.9464 45.4141L62.3633 43.1638L62.365 43.1655Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5699 52.758C73.5699 52.758 71.6345 53.2346 68.5547 51.8315C68.5547 51.8315 70.31 56.2935 74.8086 55.3974L73.5699 52.758Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2095 33.0559C75.3532 34.5398 65.417 39.5188 61.319 36.7396C61.319 36.7396 58.1146 33.1788 60.3428 30.9706C62.5711 28.7624 75.8447 24.0142 75.8447 24.0142C75.8447 24.0142 79.0709 30.3154 77.2095 33.0542V33.0559Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.574 34.8852C68.1385 41.493 66.782 43.686 64.3198 49.8155C60.3615 45.2087 54.8229 42.0606 59.8566 34.4775L64.5723 34.8852H64.574Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5221 44.6697C63.3282 47.6948 67.9295 46.4888 67.1502 43.4569C66.3441 40.4318 61.7429 41.6378 62.5221 44.6697Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9567 73.7218C89.2233 62.1839 80.423 56.3997 70.5558 57.6798C62.7216 57.6798 56.0082 64.4308 54.6029 73.7218L50.3164 116.239H97.3873L90.9567 73.7218Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4247 116.239H97.3877L91.7127 78.7108C90.5885 78.7866 89.397 77.6614 89.2303 76.9304C89.1125 76.6053 83.2373 60.3848 83.2373 60.3848C80.9703 58.5421 78.939 58.2961 78.939 58.2961L84.964 76.9472C85.2249 77.7557 84.614 78.5794 83.7657 78.5642C63.9219 78.064 71.2461 81.2845 64.0616 59.3135C64.0616 59.3135 62.4981 60.122 61.4681 61.0366L63.5398 74.7458C65.2026 79.5496 53.6692 101.644 52.3144 106.329C45.6364 119.041 52.6477 144.506 53.7096 157.956L50.9428 213.82H60.3658C61.1938 209.833 77.2829 154.203 75.9635 151.533C78.6091 156.819 83.8095 206.764 84.8243 213.698H93.5135L99.8583 158.289L97.4281 116.237L97.4247 116.239Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9615 151.535L78.1359 136.569C88.0284 151.648 85.0294 201.797 84.824 213.702C83.2033 203.599 74.8138 161.016 75.9632 151.536",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7891 109.84C54.4748 125.42 69.7915 119.503 74.078 109.702L54.2829 101.48L50.7891 109.84Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4232 213.7L93.2747 216.683L102.467 220.626C103.563 221.096 104.271 222.174 104.271 223.365H85.2891L86.0094 213.698H92.4248L92.4232 213.7Z",
    fill: "#152E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4388 213.7L59.2904 216.683L68.4827 220.626C69.5784 221.096 70.2869 222.174 70.2869 223.365H51.3047L52.025 213.698H58.4405L58.4388 213.7Z",
    fill: "#152E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4328 81.9819C69.421 84.7965 65.1446 84.7948 65.1328 81.9819C65.1446 79.1673 69.421 79.169 69.4328 81.9819Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8195 81.9819C89.8077 84.7965 85.5313 84.7948 85.5195 81.9819C85.5313 79.1673 89.8077 79.169 89.8195 81.9819Z",
    fill: "#2A437D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.805 57.6797H126.645V90.7709H155.805V57.6797Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.647 57.6797H110.504V90.7709H126.647V57.6797Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.092 57.6797H139.859V61.2438H144.092V57.6797Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69 57.6797H116.457V61.2438H120.69V57.6797Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5659 68.3131L67.3388 95.0071L49.7349 99.1743C49.7349 99.1743 42.2895 75.9501 61.4669 61.0383L62.5659 68.3131Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4062 58.2978C66.4062 58.2978 73.1146 62.8911 75.947 57.7133C75.947 57.7133 69.0115 56.3995 66.4062 58.2978Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4059 58.2979L72.5622 60.1759C69.0717 64.5621 67.6227 62.177 64.7734 58.9632C64.7734 58.9632 65.3238 58.6448 66.4059 58.2979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5625 60.176L74.9876 61.3601C76.1034 61.9058 77.4044 61.0923 77.4044 59.8492V57.8936C77.4044 57.8936 76.748 57.7656 75.9469 57.7134L72.5625 60.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.957 69.8862L96.0527 70.6885L94.3137 81.7518C94.2489 82.1645 93.8602 82.4477 93.4479 82.3828L89.8485 81.8161C89.4362 81.7512 89.1532 81.3622 89.2181 80.9496L90.957 69.8862Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.199 71.5086L89.1168 69.6053C86.562 69.2515 88.2854 65.2259 88.3089 63.7184C88.4553 62.7835 89.3322 62.1451 90.2662 62.2917L94.647 62.9823L102.348 64.195L101.199 71.5069V71.5086Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.298 64.3362L99.7288 63.7742C99.4212 63.7258 99.1326 63.9361 99.0843 64.2439L98.11 70.442C98.0617 70.7499 98.2718 71.0387 98.5794 71.0871L102.149 71.6491C102.456 71.6975 102.745 71.4872 102.793 71.1794L103.768 64.9813C103.816 64.6734 103.606 64.3846 103.298 64.3362Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.942 70.9275L99.2531 70.5031C99.0108 70.4643 98.8458 70.2369 98.8845 69.9961C100.145 63.8666 98.4268 64.259 102.88 64.9766C103.122 65.0153 103.287 65.2427 103.25 65.4836L102.452 70.557C102.414 70.7995 102.187 70.9646 101.946 70.9258L101.942 70.9275Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3595 68.1752C89.1861 68.1685 89.0902 67.9259 89.1239 67.8501C89.139 67.7558 89.7331 63.9659 89.7381 63.9491C89.7718 63.7975 89.9216 63.6981 90.0764 63.7335C90.2397 63.7486 90.3272 63.9861 90.2952 64.0569C90.2801 64.1512 89.686 67.9411 89.6809 67.9579C89.649 68.1028 89.5093 68.2005 89.3595 68.1769V68.1752Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5978 68.369C90.4244 68.3623 90.3285 68.1197 90.3621 68.0439C90.3773 67.9496 90.9714 64.1597 90.9764 64.1429C91.0084 63.998 91.1481 63.9003 91.2979 63.9239C91.4527 63.9475 91.5587 64.094 91.5335 64.249L90.9226 68.1332C90.899 68.2882 90.7526 68.3943 90.5978 68.369Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8517 68.5677C91.6783 68.561 91.5824 68.3168 91.6161 68.2426C91.6312 68.1483 92.2253 64.3585 92.2303 64.3416C92.2623 64.1968 92.402 64.0991 92.5518 64.1227C92.7066 64.1462 92.8126 64.2928 92.7874 64.4477L92.1765 68.3319C92.1529 68.4869 92.0065 68.593 91.8517 68.5677Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4834 95.4452L66.4057 99.966L87.67 75.1165L92.6953 79.8293L74.0784 109.7C72.2608 112.616 69.1271 114.452 65.6972 114.608C56.5233 115.242 54.5256 105.257 52.0938 98.6152L65.4834 95.4452Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7201 105.779L66.5585 96.9831L66.0368 93.6733L49.9375 96.9831L50.7201 105.779Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6875 76.2669C87.2462 74.1816 87.5879 70.9409 90.5398 71.2997C92.4651 71.7595 96.9805 71.2474 97.6285 73.838C98.99 76.3696 96.4134 78.3437 95.1074 80.1729C94.0538 81.7007 91.9535 81.2981 90.4018 81.0438L86.6875 76.2686V76.2669Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.963 16.4764C262.055 58.1209 238.458 58.0839 233.562 16.4764C233.936 -5.49117 266.591 -5.49117 266.963 16.4764Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.202 15.5972C259.002 27.3575 241.523 27.3558 241.324 15.5972C241.524 3.83688 259.004 3.83856 259.202 15.5972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.179 57.6797H209.383C210.559 57.6797 211.515 58.6364 211.515 59.8138V74.1175C211.515 75.2949 210.559 76.2516 209.383 76.2516H166.179C165.003 76.2516 164.047 75.2949 164.047 74.1175V59.8138C164.047 58.6364 165.003 57.6797 166.179 57.6797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.878 60.7637H167.684V63.0931H207.878V60.7637Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.878 65.8H167.684V68.1295H207.878V65.8Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.367 70.8362H167.684V73.1657H194.367V70.8362Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.742 81.5439H165.772C164.819 81.5439 164.047 82.3169 164.047 83.2704V94.8505C164.047 95.804 164.819 96.577 165.772 96.577H200.742C201.695 96.577 202.467 95.804 202.467 94.8505V83.2704C202.467 82.3169 201.695 81.5439 200.742 81.5439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.527 84.042H166.992V85.9268H199.527V84.042Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.527 88.1182H166.992V90.003H199.527V88.1182Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.59 92.1943H166.992V94.0791H188.59V92.1943Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.004 101.45H165.408C164.656 101.45 164.047 102.06 164.047 102.813V111.95C164.047 112.703 164.656 113.313 165.408 113.313H193.004C193.756 113.313 194.366 112.703 194.366 111.95V102.813C194.366 102.06 193.756 101.45 193.004 101.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.045 103.421H166.371V104.908H192.045V103.421Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.045 106.636H166.371V108.124H192.045V106.636Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.415 109.853H166.371V111.341H183.415V109.853Z",
    fill: "#DEEEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.242 184.673H423.53L417.417 223.367H397.994L391.242 184.673Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M397.873 180.37C397.873 180.37 394.696 214.822 419.777 220.362L418.188 225.036H394.208L389.332 181.234L397.873 180.368V180.37Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.422 177.631C411.422 177.631 419.342 164.112 440.101 168.611C440.101 168.611 428.788 190.121 411.422 177.631Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.73 196.82C408.73 196.82 415.005 186.109 431.454 189.673C431.454 189.673 422.49 206.714 408.73 196.82Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.008 162.255C431.008 162.255 436.309 153.206 450.205 156.216C450.205 156.216 442.634 170.614 431.008 162.255Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.758 138.296C429.758 138.296 433.57 131.789 443.56 133.955C443.56 133.955 438.115 144.306 429.758 138.296Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.935 137.93C429.935 137.93 424.982 132.245 430.208 123.453C430.208 123.453 438.284 131.908 429.935 137.93Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.656 131.093C436.656 131.093 439.145 123.975 449.366 124.176C449.366 124.176 446.014 135.382 436.656 131.093Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.77 145.018C424.77 145.018 417.074 140.502 419.635 128.666C419.635 128.666 431.879 135.115 424.77 145.018Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.083 172.788C413.083 172.788 400.035 170.348 397.66 152.483C397.66 152.483 418.049 155.338 413.083 172.788Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.934 156.574C418.934 156.574 407.461 153.108 407.074 136.842C407.074 136.842 425.095 141.398 418.934 156.574Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.608 192.376L408.043 192.285C409.196 179.905 422.533 137.12 439.504 129.099L439.804 129.588C422.93 137.612 409.765 180.143 408.608 192.376Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.047 184.673H405.475C404.43 164.533 384.271 132.367 373.379 118.368L373.838 118.024C384.184 130.6 405.896 166.873 406.049 184.673H406.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.971 174.612C403.971 174.612 394.144 167.607 380.809 172.788C380.809 172.788 396.321 185.613 403.971 174.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.542 169.876C402.542 169.876 400.893 159.947 412.83 152.483C412.83 152.483 417.305 169.266 402.542 169.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.242 163.597C400.242 163.597 387.476 166.746 378.484 159.465C378.484 159.465 394.621 153.066 400.242 163.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.243 157.098C397.243 157.098 392.409 147.004 403.946 139.844C403.946 139.844 404.734 155.331 397.243 157.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.127 150.344C394.127 150.344 388.836 154.957 377.129 147.558C377.129 147.558 386.964 141.083 394.127 150.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.441 145.941C391.441 145.941 388.068 139.781 397.792 129.917C397.792 129.917 402.011 140.918 391.441 145.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.027 135.058C372.027 135.058 377.911 131.23 388.47 140.194C388.47 140.194 377.827 145.23 372.027 135.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.393 136.643C386.393 136.643 382.25 131.883 388.894 121.353C388.894 121.353 394.709 130.199 386.393 136.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.488 129.298C381.488 129.298 377.401 133.135 367.844 127.574C367.844 127.574 375.501 122.119 381.488 129.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.028 126.889C380.028 126.889 377.275 123.739 381.666 116.749C381.666 116.749 385.533 122.606 380.028 126.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.513 120.689C375.513 120.689 371.349 121.073 368.27 113.412C368.27 113.412 375.277 113.716 375.513 120.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.049 145.98H225.852V223.367H294.049V145.98Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.85 145.98H188.098V223.367H225.85V145.98Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.648 145.98H256.75V154.317H266.648V145.98Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.921 145.98H202.023V154.317H211.921V145.98Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.544 94.6401H239.301V145.98H284.544V94.6401Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.304 94.6401H214.258V145.98H239.304V94.6401Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.368 94.6401H259.801V100.172H266.368V94.6401Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.063 94.6401H223.496V100.172H230.063V94.6401Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.679 58.9751H243.25V94.6401H274.679V58.9751Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25 58.9751H225.852V94.6401H243.25V58.9751Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.049 58.9751H257.488V62.8171H262.049V58.9751Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.83 58.9751H232.27V62.8171H236.83V58.9751Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.02 172.027H306.777V223.367H352.02V172.027Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.78 172.027H281.734V223.367H306.78V172.027Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.844 172.027H327.277V177.559H333.844V172.027Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.54 172.027H290.973V177.559H297.54V172.027Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.04 120.687H314.797V172.027H360.04V120.687Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.8 120.687H289.754V172.027H314.8V120.687Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.864 120.687H335.297V126.219H341.864V120.687Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.559 120.687H298.992V126.219H305.559V120.687Z",
    fill: "#FDF1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.757 145.693H214.258V146.266H289.757V145.693Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.024 171.74H281.734V172.313H352.024V171.74Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.68 94.3538H225.852V94.9265H274.68V94.3538Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 223.683C153.384 223.262 313.618 223.259 467 223.683C313.616 224.108 153.382 224.104 0 223.683Z",
    fill: "#F1F5F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3134_18038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 467,
    height: 224,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderConsignmentVector);
export default __webpack_public_path__ + "static/media/order-consignment-vector.044ca75a59e3d337fc7ab9549d01f0e2.svg";
export { ForwardRef as ReactComponent };